import React, { useRef, useState, useEffect } from 'react';
import './BuildersSection.css';

import zaheerImg from '../assets/zaheer_founder.jpeg';
import sohailImg from '../assets/sohail_founder.jpeg';

/* ── scroll reveal ── */
function useFadeIn(threshold = 0.15) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setVisible(true); io.unobserve(el); } },
      { threshold }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [threshold]);
  return [ref, visible];
}

/* LinkedIn icon */
const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="15" height="15">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

const GitHubIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
    <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.11.825-.26.825-.58 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 21.795 24 17.31 24 12c0-6.63-5.37-12-12-12z" />
  </svg>
);

const InstaIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.17.054 1.805.249 2.227.412.56.216.96.474 1.38.894.42.42.678.82.894 1.38.163.422.358 1.057.412 2.227.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.054 1.17-.249 1.805-.412 2.227-.216.56-.474.96-.894 1.38-.42.42-.82.678-1.38.894-.422.163-1.057.358-2.227.412-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.17-.054-1.805-.249-2.227-.412-.56-.216-.96-.474-1.38-.894-.42-.42-.678-.82-.894-1.38-.163-.422-.358-1.057-.412-2.227-.058-1.266-.07-1.646-.07-4.85s.012-3.584.07-4.85c.054-1.17.249-1.805.412-2.227.216-.56.474-.96.894-1.38.42-.42.82-.678 1.38-.894.422-.163 1.057-.358 2.227-.412 1.266-.058 1.646-.07 4.85-.07zM12 0c-3.259 0-3.667.014-4.947.072-1.277.057-2.15.26-2.914.558-.79.308-1.46.72-2.127 1.388-.668.667-1.08 1.337-1.387 2.127-.299.764-.501 1.637-.558 2.914C.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.057 1.277.26 2.15.558 2.914.308.79.72 1.46 1.388 2.127.667.668 1.337 1.08 2.127 1.387.764.299 1.637.501 2.914.558 1.28.058 1.688.072 4.948.072 3.259 0 3.668-.014 4.948-.072 1.277-.057 2.15-.26 2.914-.558.79-.308 1.46-.72 2.127-1.388.668-.667 1.08-1.337 1.387-2.127.299-.764.501-1.637.558-2.914.058-1.28.072-1.688.072-4.948s-.014-3.668-.072-4.947c-.057-1.277-.26-2.15-.558-2.914-.308-.79-.72-1.46-1.388-2.127-.667-.668-1.337-1.08-2.127-1.387-.764-.299-1.637-.501-2.914-.558C15.667.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
  </svg>
);

export function BuildersSection() {
  const [heroRef, heroVis] = useFadeIn(0.15);
  const [z1Ref, z1Vis] = useFadeIn(0.1);
  const [s1Ref, s1Vis] = useFadeIn(0.1);
  const [whyRef, whyVis] = useFadeIn(0.15);

  return (
    <section className="builders-section" id="builders">

      {/* ── Intro ── */}
      <div
        ref={heroRef}
        className={`builders-hero builders-fade ${heroVis ? 'builders-fade--visible' : ''}`}
      >
        <h2>
          The Builders Behind <span className="highlight">BharatQA</span>
        </h2>
        <p>
          Built by two guys from Karnataka who got tired of watching Indian startups
          ship apps that broke on real phones.
        </p>
      </div>

      {/* ── Founders ── */}
      <div className="builders-founders">

        {/* Zaheer — image left, text right */}
        <div
          ref={z1Ref}
          className={`builder-card builders-fade ${z1Vis ? 'builders-fade--visible' : ''}`}
        >
          <div className="builder-image-wrap">
            <div className="builder-image-container">
              <img src={zaheerImg} alt="Zaheer Kundgol" className="builder-photo" loading="lazy" />
              <span className="builder-role-badge">Cofounder & Lead Tester</span>
            </div>
          </div>

          <div className="builder-story">
            <h3 className="builder-name">Zaheer Kundgol</h3>
            <p className="builder-role">Cofounder & Lead Tester</p>
            <a
              href="https://www.linkedin.com/in/zaheer-kundgol/"
              target="_blank"
              rel="noopener noreferrer"
              className="builder-linkedin"
            >
              <LinkedInIcon /> LinkedIn
            </a>

            <blockquote className="builder-quote">
              "Got tired of Indian startups shipping broken apps tested only on emulators."
            </blockquote>

            <p className="builder-bio">
              Zaheer is from Hubli, Karnataka. Spent over 3 years testing Android apps on actual devices.
              He kept seeing the same crashes happen on real Indian hardware that never showed up in emulators.
              So he started building BharatQA.
            </p>


          </div>
        </div>

        <div className="builders-divider" />

        {/* Sohail — text left, image right */}
        <div
          ref={s1Ref}
          className={`builder-card builder-card--reverse builders-fade ${s1Vis ? 'builders-fade--visible' : ''}`}
        >
          <div className="builder-image-wrap">
            <div className="builder-image-container">
              <img src={sohailImg} alt="Sohail Ahmed Kundgol" className="builder-photo" loading="lazy" />
              <span className="builder-role-badge">Cofounder & Data Operations</span>
            </div>
          </div>

          <div className="builder-story">
            <h3 className="builder-name">Sohail Ahmed Kundgol</h3>
            <p className="builder-role">Cofounder & Data Operations</p>
            <a
              href="https://www.linkedin.com/in/sohail-ahmed-kundgol/"
              target="_blank"
              rel="noopener noreferrer"
              className="builder-linkedin"
            >
              <LinkedInIcon /> LinkedIn
            </a>

            <blockquote className="builder-quote">
              "Every crash has a story. We find them before your users do."
            </blockquote>

            <p className="builder-bio">
              Sohail handles the data side. He turned messy test logs into clear reports
              that actually help developers. No bullshit, just useful information.
            </p>


          </div>
        </div>
      </div>

      {/* ── Why This Team ── */}
      <div
        ref={whyRef}
        className={`builders-why builders-fade ${whyVis ? 'builders-fade--visible' : ''}`}
      >
        <h3 className="builders-why-title">Why This Team</h3>
        <div className="builders-why-grid">
          <div className="builders-why-card">
            <strong>Built in India, For India</strong>
            <span>We know the devices, networks, and real user conditions here.</span>
          </div>
          <div className="builders-why-card">
            <strong>Developers First</strong>
            <span>We build what we needed ourselves — nothing extra.</span>
          </div>
          <div className="builders-why-card">
            <strong>Real Data, No Guesswork</strong>
            <span>Everything is based on actual device telemetry.</span>
          </div>
          <div className="builders-why-card">
            <strong>Just Honest Work</strong>
            <span>Solving a real problem because we care about Indian apps working properly.</span>
          </div>
        </div>
      </div>

      <div className="builders-socials builders-fade">
        <a href="https://github.com/fundup7" target="_blank" rel="noopener noreferrer">
          <GitHubIcon /> GitHub
        </a>
        <a href="https://www.instagram.com/bharatqa/" target="_blank" rel="noopener noreferrer">
          <InstaIcon /> Instagram
        </a>
        <a href="https://www.linkedin.com/company/bharatqa/" target="_blank" rel="noopener noreferrer">
          <LinkedInIcon /> LinkedIn
        </a>
      </div>
    </section>
  );
}
